
















export default

	props:
		sections: Array
		current: String

	methods:
		go: (id) -> @$emit('go', id)

